// modifies provided brazilian text to be searchable
export const brazilian_text_to_searchable = (text: string) => text?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase() || ''